module.exports = __webpack_public_path__ + "img/shipo-popup-icon-success.8c85d1f0.svg";